import { useCallback } from 'react';
import { Preference } from '../../models/Preference';
import { useFetchMyContentPreferences } from './index';
import useCreateMyContentPreferences from './useCreateMyContentPreferences';

type UseAddPreferencesModal = (newPreferences: Preference[]) => void;

const useAddPreferencesModal = (onSuccessCallback: () => void, onErrorCallback: () => void): UseAddPreferencesModal => {
  const { data: preferences, isLoading } = useFetchMyContentPreferences();
  const { mutate } = useCreateMyContentPreferences();

  return useCallback(
    (newPreferences) => {
      if (isLoading) {
        return;
      }

      const preferencesToUpdate: Preference[] = [...newPreferences, ...(preferences || [])];

      mutate(preferencesToUpdate, {
        onSuccess: onSuccessCallback,
        onError: onErrorCallback,
      });
    },
    [mutate, preferences, isLoading]
  );
};

export default useAddPreferencesModal;
